// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage, ref } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyChCd7b4O41oDfl8izpuenU7D3Fvq6qL9o",
  authDomain: "verify-swimmunity.firebaseapp.com",
  projectId: "verify-swimmunity",
  storageBucket: "verify-swimmunity.appspot.com",
  messagingSenderId: "223585130602",
  appId: "1:223585130602:web:9a0f274ae596f8b023d213"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage();
export const storageRef = ref(storage,'lifeguard-certificate')
